/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PayerSearchOptionsPayerRequiredFieldsInner
 */
export interface PayerSearchOptionsPayerRequiredFieldsInner {
    /**
     * 
     */
    is_active: boolean;
    /**
     * 
     */
    prompt: string;
    /**
     * 
     */
    payer_required_field_type_id: number;
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    alt_param_element_name: string;
}

/**
 * Check if a given object implements the PayerSearchOptionsPayerRequiredFieldsInner interface.
 */
export function instanceOfPayerSearchOptionsPayerRequiredFieldsInner(value: object): value is PayerSearchOptionsPayerRequiredFieldsInner {
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('payer_required_field_type_id' in value) || value['payer_required_field_type_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('alt_param_element_name' in value) || value['alt_param_element_name'] === undefined) return false;
    return true;
}

export function PayerSearchOptionsPayerRequiredFieldsInnerFromJSON(json: any): PayerSearchOptionsPayerRequiredFieldsInner {
    return PayerSearchOptionsPayerRequiredFieldsInnerFromJSONTyped(json, false);
}

export function PayerSearchOptionsPayerRequiredFieldsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerSearchOptionsPayerRequiredFieldsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'is_active': json['is_active'],
        'prompt': json['prompt'],
        'payer_required_field_type_id': json['payer_required_field_type_id'],
        'id': json['id'],
        'alt_param_element_name': json['alt_param_element_name'],
    };
}

export function PayerSearchOptionsPayerRequiredFieldsInnerToJSON(json: any): PayerSearchOptionsPayerRequiredFieldsInner {
    return PayerSearchOptionsPayerRequiredFieldsInnerToJSONTyped(json, false);
}

export function PayerSearchOptionsPayerRequiredFieldsInnerToJSONTyped(value?: PayerSearchOptionsPayerRequiredFieldsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_active': value['is_active'],
        'prompt': value['prompt'],
        'payer_required_field_type_id': value['payer_required_field_type_id'],
        'id': value['id'],
        'alt_param_element_name': value['alt_param_element_name'],
    };
}

